import { render, staticRenderFns } from "./AHFileUpload.vue?vue&type=template&id=36ee36aa&"
import script from "./AHFileUpload.vue?vue&type=script&lang=ts&"
export * from "./AHFileUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports